import config from "@/config";
import { ChainsListRegistryResponse } from "@/utils/interface";

const fetchChains = async (): Promise<ChainsListRegistryResponse> => {
  const response = await fetch(config.web3AuthChainsUrl);
  const data = (await response.json()) as ChainsListRegistryResponse;
  return data;
};

export interface IChainsListRegistry {
  fetchChains: () => Promise<ChainsListRegistryResponse>;
}
const ChainsListRegistry = {
  fetchChains,
};

export default ChainsListRegistry;
